<template>
  <div class="page-breadcrumbs">
    <router-link
      class="page-breadcrumbs-segment"
      v-for="(parent, index) in parents"
      :key="parent.path"
      :to="parent[1]"
    >
      <span class="page-breadcrumb-location-label label">{{labels[index]}}</span>
      <span>{{parent[0]}}</span>
    </router-link>
    <div class="page-breadcrumbs-segment">
      <span class="page-breadcrumb-location-label label">{{labels[parents.length]}}</span>
      <span class="page-breadcrumb-location">{{currentLocation}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    parents: {
      type: Array
    },
    currentLocation: {
      type: String
    }
  },
  data() {
    return {
      labels: ["Klant", "Project", "Ruimte", "Meting"]
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/base-components/base-breadcrumbs.vue